module.exports = __webpack_public_path__ + "static/media/jackpots-lvl3.58a923b2.png";